<template>
    <div class="fadein">
        <div class="h20"></div>
            <!-- temp-1 start-->
            <div class="center1200 bg-white temp-1 shadow">
            <div class="h20"></div>
            <div class="center-title">
                <a href="#"> <img class="title-pic" src="/static/img/title-left.png" alt=""> 电影总览 <img class="title-pic" src="/static/img/title-right.png" alt=""> </a>
            </div>
            <div class="h20"></div>
            <div class="movieboxes">
            <div class="moviebox" v-for="v in movies">
                <a href="javascript:;" @click="goMovieDetail(v.id)">
                <img :src="v.cover" alt="" class="moviepic" />
                </a>
                <a href="" @click="goMovieDetail(v.id)">{{v.title}}</a>
                <p>
                <span v-for="val in v.withtypes">
                    {{val.type}}
                </span>
                </p>
            </div>
            <span v-if="flex_movies_align!=0">
                <div style="width:172px;" v-for="n in flex_movies_align"></div>
            </span>
                
            </div>

        <div class="h10"></div>
        <div style="text-align: center;">
            <el-pagination
            layout="prev, pager, next"
            :total="total"
            :page-size="pagesize"
            :current-page="page"
            @current-change="currentChange"
            hide-on-single-page>
            </el-pagination>
            <!-- {{comment_length}} -->
        </div>
        <div class="h30"></div>
        </div>
        <!-- temp-1 end-->
    </div>
</template>
<script>
    export default{
        data(){
            return {
                loading:0,
                //当前页码
                page:1,
                //电影列表（12条）
                movies:[],
                pagesize:12,
                //电影总条数
                total:0,

                flex_movies_align:0,
            }
        },
        watch:{
            $route(newVal,oldVal){
            if(newVal.name == 'movies'){
                this.loading = 0;
                this.$parent.activeIndex = '2'

                }
            }

        },
        mounted(){
            this.loading = 0;
            this.getMovies();

        },
        methods:{
            //获取电影（默认12条）
            getMovies(){
                $.ajax({
                    url:"//" + this.$API_URL + "/api/v1/movies",
                    type:"get",
                    data:{page:this.page},
                    success:(ret)=>{
                        
                        this.movies = ret.data
                        this.total = ret.total
                        this.flex_movies_align = 6 - (this.movies.length % 6)
                        this.loading = 1
                        this.openFullScreen();
                    }
                })
            },
        
            //页面跳转
            currentChange(val){
                this.page = val
                
                this.getMovies();
            },
            //页面加载中
            openFullScreen() {
            const loading = this.$loading({
            lock: true,
            text: "页面加载中（￣口￣）。。。",
            spinner: 'el-icon-loading',
            background: 'rgba(255, 255, 255, 0.7)'
            });
            // setTimeout(() => {
            if(this.loading==1){
                loading.close();
            }
            // }, 2000);
            },

            //跳转到电影详情
            goMovieDetail(id){
                // 
                this.$router.push('/movie/'+id);
            },
        },

    }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/index/movies.vue